import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaShoppingCart,
  FaBars,
  FaTimes,
  FaHome,
  FaChevronDown,
  FaUser
} from "react-icons/fa";
import { useCart } from "../cart/CartContext";
import heroImg from "../assets/venue.jpg"; // add a background image
import "../styles/OtherServicesPage.css";

const servicesLinks = [
  { to: "/wedding", label: "Wedding Planning" },
  { to: "/design", label: "Design & Decoration" },
  { to: "/destination", label: "Destination Wedding Venues" },
  { to: "/entertainment", label: "Entertainment" },
  { to: "/others", label: "Custom Events" },
];

function OtherServicesPage() {
  const { cart } = useCart();
  const [dropdown, setDropdown] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const dropdownTimeout = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleNav = () => {
    setNavOpen(!navOpen);
    document.body.classList.toggle("nav-open", !navOpen);
  };

  return (
    <div className="other-services-page">
      {/* NAVBAR */}
      <header className={`desktop-navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="navbar-container">
          <div
            className="navbar-brand"
            onClick={() => navigate("/")}
            style={{ fontFamily: "'Great Vibes', cursive" }}
          >
            Parivar
          </div>

          <nav className="center-nav">
            <Link to="/" className="nav-link">
              <FaHome /> Home
            </Link>

            <div
              className="dropdown"
              onMouseEnter={() => {
                clearTimeout(dropdownTimeout.current);
                setDropdown(true);
              }}
              onMouseLeave={() => {
                dropdownTimeout.current = setTimeout(() => setDropdown(false), 200);
              }}
            >
              <button className="dropdown-btn" style={{ border: "none", outline: "none" }}>
                Services <FaChevronDown />
              </button>
              <div className={`dropdown-menu ${dropdown ? "show" : ""}`}>
                {servicesLinks.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="dropdown-link"
                    onClick={() => setDropdown(false)}
                  >
                    {item.label}
                  </Link>
                ))}
              </div>
            </div>
          </nav>

          <div className="nav-right">
            {/* NEW: Profile button */}
            <Link to="/profile" className="profile-link" aria-label="Profile">
              <FaUser size={18} />
            </Link>

            <Link to="/cart" className="cart-link" aria-label="Cart">
              <FaShoppingCart size={18} />
              {cart.length > 0 && <span className="cart-badge">{cart.length}</span>}
            </Link>
          </div>

          <div className="mobile-menu-icon" onClick={toggleNav}>
            {navOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
          </div>
        </div>
      </header>

      {/* MOBILE MENU */}
      {navOpen && (
        <div className="sidebar-overlay" onClick={toggleNav}>
          <div className="sidebar" onClick={(e) => e.stopPropagation()}>
            <div className="sidebar-header">
              <span>Menu</span>
              <FaTimes onClick={toggleNav} />
            </div>
            <div
              className="sidebar-link"
              onClick={() => { navigate("/"); toggleNav(); }}
            >
              <FaHome /> Home
            </div>
            <div
              className="sidebar-link"
              onClick={() => setDropdown(!dropdown)}
            >
              <FaChevronDown /> Services
            </div>
            {dropdown && (
              <div className="sidebar-submenu">
                {servicesLinks.map((link) => (
                  <div
                    key={link.to}
                    className="sidebar-submenu-item"
                    onClick={() => { navigate(link.to); toggleNav(); }}
                  >
                    {link.label}
                  </div>
                ))}
              </div>
            )}

            {/* NEW: Profile in sidebar */}
            <div
              className="sidebar-link"
              onClick={() => { navigate("/profile"); toggleNav(); }}
            >
              <FaUser /> Profile
            </div>

            <div
              className="sidebar-link"
              onClick={() => { navigate("/cart"); toggleNav(); }}
            >
              <FaShoppingCart /> Cart
              {cart.length > 0 && <span className="cart-badge">{cart.length}</span>}
            </div>
          </div>
        </div>
      )}

      {/* HERO SECTION */}
      <section className="hero" style={{ backgroundImage: `url(${heroImg})` }}>
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1>Other Services</h1>
          <p>Logistics • Hospitality • Guest Handling • Gift Curation</p>
        </div>
      </section>

      {/* FEATURES SECTION */}
      <section className="features-section">
        <h2>What We Offer</h2>
        <div className="features-grid">
          <div className="feature-card">
            <h3>Seamless Logistics</h3>
            <p>Efficient transport, scheduling, and coordination for smooth operations.</p>
          </div>
          <div className="feature-card">
            <h3>Premium Hospitality</h3>
            <p>Guest comfort and luxury accommodations tailored to your event.</p>
          </div>
          <div className="feature-card">
            <h3>Gift Curation</h3>
            <p>Beautifully crafted, personalized gifts to make memories last.</p>
          </div>
          <div className="feature-card">
            <h3>Guest Handling</h3>
            <p>From arrival to departure, we take care of your guests’ every need.</p>
          </div>
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="cta-section">
        <h2>Let Us Handle the Details</h2>
        <p>Your event, our expertise — stress-free and unforgettable.</p>
        <Link to="/contact" className="cta-btn">Contact Us</Link>
      </section>
    </div>
  );
}

export default OtherServicesPage;
